var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('region-form',{model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}})}
var staticRenderFns = []

export { render, staticRenderFns }